import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MerchantAccountInfoComponent } from '../merchant-account-info/merchant-account-info.component';
import { BillingInformationComponent } from '../merchant-billing-info/merchant-billing-info.component';
import { MerchantContactComponent } from '../merchant-contact/merchant-contact.component';
import { MerchantService } from '../../../models/merchant/merchantService';
import { Merchant } from '../../../models/merchant/merchant';
import { User } from '../../../models/users/user';
import {
  CardBrand,
  FormMode,
  MerchantAccountStatus,
  ProcessorName,
  ProcessorType,
} from '../../../core/constants';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { UIHelpers } from '../../../core/ui-helpers';
import { SiteDataService } from '../../../models/ui/siteDataService';
import { UserFormComponent } from '../../user/user-form/user-form.component';
import { BaseComponent } from '../../baseComponent';
import { CacheService } from '../../../core/storage/cacheService';
import { AssignedUser } from '../../../models/users/assignedUser';
import { Logging } from '../../../core/logging';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoadingSpinnerComponent } from '../../loading-spinner/loading-spinner.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../../ui/snackbar/custom-snackbar.component';
import { MerchantProcessor } from '../../../models/merchant/merchantProcessor';
import { MerchantProcessorsComponent } from '../merchant-processors/merchant-processors.component';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';
import { AccessManager } from '../../ui/access-manager/access-manager';

@Component({
  selector: 'app-merchant-onboarding',
  templateUrl: './merchant-onboarding.component.html',
  standalone: false,
})
export class MerchantOnboardingComponent extends BaseComponent {
  @Input() accountId: string | undefined;
  @Output() newMerchantId = new EventEmitter<string>();
  namespace: string = AccessManager.AUTH_INSERT_MERCHANTS;

  @ViewChild('businessInfoForm') businessInfoForm:
    | MerchantAccountInfoComponent
    | undefined;
  @ViewChild('billingInfoForm') billingInfoForm:
    | BillingInformationComponent
    | undefined;
  @ViewChild('contactForm') contactForm: MerchantContactComponent | undefined;
  @ViewChild('userForm') userForm: UserFormComponent | undefined;
  @ViewChild('processingForm') processingForm:
    | MerchantProcessorsComponent
    | undefined;

  annualRevenue: number | undefined = undefined;
  //exceedsRevenueCutoff: string | undefined = undefined;
  revenueEntered: boolean = false;
  user: Partial<User> | undefined;
  selectedProcessor: string | undefined;
  selectedGateway: string | undefined;
  selectedProcessingType: string | undefined;

  acceptVisa: boolean = true;
  acceptMastercard: boolean = true;
  acceptAmex: boolean = false;
  acceptDiscover: boolean = false;

  processorOptions: ListItem[] = [];
  gatewayOptions: ListItem[] = CacheService.gatewayList;
  processingOptions: ListItem[] = CacheService.processingTypeList;
  
  integrationOptions: ListItem[] = CacheService.integrationList;

  intergations: string[] = [];

  campfireApiKey: string = '';

  public get formMode(): typeof FormMode {
    return FormMode;
  }

  // FOR TESTING:
  //testMerchant: Partial<Merchant>;
  //testUser: Partial<User>;

  constructor(
    private merchantService: MerchantService,
    private siteDataService: SiteDataService,
    public dialogRef: MatDialogRef<MerchantOnboardingComponent>,
    public loadingSpinnerDialog: MatDialog,
    private uiErrorHandler: UIErrorHandler,
    private snackBar: MatSnackBar,
  ) {
    super();

    this.revenueEntered = true;

    this.siteDataService
      .getProcessorListItems()
      .then((procs) => {
        this.processorOptions = procs;

        /*
      this.siteDataService.getGatewayListItems()
      .then(gateways => {
        this.gatewayOptions = gateways;
      })
      */
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });

    // FOR TESTING
    /*
    this.testMerchant = {
      DBA: "Test Merchant",
      legalName: "Test Merchant, LLC",
      MID: "123456789",
      EIN: "12-34567890",
      timezone: "CST",
      streetAddress: {
        city: "St. Louis",
        state: "MO",
        country: "US",
        street1: "123 Main St.",
        street2: "Suite 1A",
        postalCode: "63101"
      },
      website: "http://www.nowhere.com",
      // processing:
      billingAccountHolderType: "Personal",
      billingAccountType: "Checking",
      billingAccountNum: "000135792468",
      billingRoutingNum: "2468013579",
      billingAddress: {
        city: "Chicago",
        state: "IL",
        country: "US",
        street1: "9999 S. Market St.",
        street2: "Box 55",
        postalCode: "60543"
      },
      // contact:
      contact: {
        firstName: "Merchant",
        lastName: "Manager",
        emailAddress: "merchant@swipesum.com",
        phone: "3145551212",
        fax: "6362221234",
      },
      
    };

    this.selectedProcessor = "Elavon";
    this.acceptAmex = true;
    this.acceptDiscover = true;
    this.acceptMastercard = true;
    this.acceptVisa = true;
    */

    /*
    this.testUser = {
      firstName: "Merchant",
      lastName: "Manager",
      emailAddress: "merchant@swipesum.com",
      originalRole: "Merchant Manager",
    }
    */
  }

  public reset() {
    this.user = undefined;
    //this.businessInfoForm.reset();
    //this.userForm.reset();
    //this.billingInfoForm.reset();
  }

  handleNewUserSaved_callback(user: Partial<User>) {
    this.user = user;
  }

  doValidation(): boolean {
    let formErrors = this.businessInfoForm?.validate();

    if (formErrors && formErrors?.length > 0) {
      UIHelpers.scrollToTop('onboarding_businessInformationContainer');
      return false;
    }

    // formErrors = this.billingInfoForm?.validate();
    // if (formErrors && formErrors?.length > 0) {
    //   UIHelpers.scrollToTop("onboarding_billingInformationContainer");
    //   return false;
    // }

    // if (this.selectedProcessor && this.selectedProcessor != "") {
    //   if (!(this.acceptAmex || this.acceptDiscover || this.acceptMastercard || this.acceptVisa)) {
    //     UIHelpers.scrollToTop("onboarding_processingInformationContainer")
    //     .then(() => {
    //       this.uiErrorHandler.handleError("Please select at least one card brand to process.");
    //     });
    //     return false;
    //   }
    // }

    formErrors = this.contactForm?.validate();
    if (formErrors && formErrors?.length > 0) {
      UIHelpers.scrollToTop('onboarding_contactInformationContainer');
      return false;
    }

    formErrors = this.processingForm?.validate();
    if (formErrors && formErrors?.length > 0) {
      UIHelpers.scrollToTop('onboarding_processingInformationContainer');
      return false;
    }

    

    // This should also handle the case where the user meant to select
    // an existing user but forgot to
    // formErrors = this.userForm?.validate();
    // if ((formErrors && formErrors.length > 0)) {
    //   UIHelpers.scrollToTop("onboarding_userInformationContainer");
    //   return false;
    // }
    

    return true;
  }

  onIntegrationChange(event: any) {
    if (!this.intergations.includes(event)) {
      this.intergations.push(event);
    }
  }

  onCampfireApiKeyChange(event: any) {
    this.campfireApiKey = event;
  }

  btnSave_click() {
    let loadingSpinnerRef = this.loadingSpinnerDialog.open(
      LoadingSpinnerComponent,
      {
        disableClose: true,
        panelClass: 'transparent-dialog',
        data: {
          mode: 'indeterminate',
        },
      },
    );

    if (!this.doValidation()) {
      loadingSpinnerRef.close();

      this.snackBar.openFromComponent(CustomSnackbarComponent, {
        data: {
          message: 'Please correct the errors in the form.',
          fontSize: '16px',
          iconSize: '24px',
        },
        duration: 3000,
        panelClass: 'snackbar-error',
      });
      return;
    }

    let merchantData: Merchant = Merchant.createEmpty();
    let processingData: Partial<MerchantProcessor> =
      MerchantProcessor.createEmpty();
    if (this.processingForm != undefined) {
      this.processingForm.getData(processingData);
      merchantData.MID = processingData.mid;
      merchantData.tokenVaultName = processingData.tokenVaultName;
      merchantData.gateway = processingData.gateway;
      merchantData.achMid = processingData.achMid;

      for (const processor of processingData.processor!) {
        const processorType =
          processor == ProcessorName.Paya
            ? ProcessorType.ACH
            : ProcessorType.Card;
        const mid =
          processor == ProcessorName.Paya
            ? processingData.achMid
            : processingData.mid;
        const merchantProcessor: Partial<MerchantProcessor> = {
          processor: processor,
          processorType: processorType,
          mid: mid,
          ppdTerminalId: processingData.ppdTerminalId,
          ccdTerminalId: processingData.ccdTerminalId,
          webTerminalId: processingData.webTerminalId,
          cardTerminalId: processingData.cardTerminalId,
        };
        merchantData.processors.push(merchantProcessor as MerchantProcessor);
      }
    }
    if (this.intergations) {
      merchantData.integrations = this.intergations;
    }
    if (this.intergations.includes('Campfire')) {
      merchantData.campfireMerchant = {
        apiKey: this.campfireApiKey,
        campfireId: 0,
        paymentLink: '',
      };
    }
    let primaryUser: Partial<User> = User.createEmpty();
    //let userData: Partial<User>[] = [];
    let acceptedCards: string[] = [];

    if (this.accountId != undefined) {
      if (
        confirm(
          `You're account already has a business associated with it. Do you want to add this merchant to it?`,
        )
      ) {
        merchantData.accountId = this.accountId;
      } else {
        merchantData.accountId = '';
      }
    }

    if (this.businessInfoForm != undefined) {
      this.businessInfoForm.getData(merchantData);
    }
    if (this.billingInfoForm != undefined) {
      this.billingInfoForm.getData(merchantData);
    }
    if (merchantData.brandName == undefined || merchantData.brandName == '') {
      merchantData.brandName = 'N/A';
    }
    if (this.contactForm != undefined) {
      // TODO...
      //merchantData.contact = this.contactForm.getData();
    }
    if (this.userForm != undefined) {
      this.user = this.userForm.getData();
      if (this.user) {
        let assignedUser = new AssignedUser({
          userId: this.user.id,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          emailAddress: this.user.emailAddress,
          contactTypes: ['Primary'],
          phone: this.user.phone,
          fax: this.user.fax,
          accessBits: this.user.accessBits ? this.user.accessBits : '0',
        });
        merchantData.users.push(assignedUser as AssignedUser);
      }
    }

    //merchantData.processor = this.selectedProcessor;

    if (this.acceptVisa == true) {
      acceptedCards.push(CardBrand.Visa);
    }
    if (this.acceptMastercard == true) {
      acceptedCards.push(CardBrand.Mastercard);
    }
    if (this.acceptAmex == true) {
      acceptedCards.push(CardBrand.Amex);
    }
    if (this.acceptDiscover == true) {
      acceptedCards.push(CardBrand.Discover);
    }

    if (this.user) {
      //merchantData.contacts.push(this.user as MerchantContact);
      //merchantData.users.push(this.user as AssignedUser);
      merchantData.MID = processingData.mid;
      Logging.verbose(
        'merchant-onboarding-component',
        'btnSave_click',
        'Submitting new merchant account',
        merchantData,
        this.user,
        acceptedCards,
      );

      this.merchantService
        .addMerchantAccount(merchantData)
        .then((response: string) => {
          loadingSpinnerRef.close();
          this.newMerchantId.emit(response);
        })
        .catch((message) => {
          loadingSpinnerRef.close();
          this.uiErrorHandler.handleError(message);
        });
    } else {
      UIHelpers.scrollToTop('onboarding_userInformationContainer');
      return;
    }
  }
}
